export var OfferTab;
(function (OfferTab) {
    OfferTab["OBJECTS"] = "objects";
    OfferTab["GOODS_AND_SERVICES"] = "goods-and-services";
    OfferTab["UNIFIED"] = "unified";
})(OfferTab || (OfferTab = {}));
export const offerTabRouteMap = {
    [OfferTab.OBJECTS]: 'Offers',
    [OfferTab.GOODS_AND_SERVICES]: 'GoodsAndServices',
    [OfferTab.UNIFIED]: 'UnifiedOffers',
};
